import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pipeSplitIndex'
})
export class PipeSplitIndexPipe implements PipeTransform {
  transform(value: string, ...args) {
    const i = Number(args[0]);
    return value.split('|')[i];
  }
}
